/**
 * This is the entry file for webpack/config/tenant.js
 */


// Nette forms
import netteForms from 'nette-forms';
window.Nette = netteForms;
netteForms.initOnLoad();

// Tom Select
import TomSelect from 'tom-select';
window.TomSelect = TomSelect;


// Cookies
import '/node_modules/vanilla-cookieconsent/dist/cookieconsent.js';


// Application
import '/webpack/assets/js/tenant/flashMessenger.js';
import '/webpack/assets/js/tenant/netteFormsExtension.js';
import '/webpack/assets/js/formOptionRules.js';
import '/webpack/assets/js/formRequiredTriggers.js';
import '/webpack/assets/js/tomSelectInit.js';
import '/webpack/assets/js/tenant/general.js';
import '/webpack/assets/js/tenant/signIn.js';
import '/webpack/assets/js/addressAutocomplete.js';
import {initDatePickers} from '/webpack/assets/js/datePicker/datePickerInit.js';

document.addEventListener('DOMContentLoaded', () => initDatePickers(document));
